import React from 'react';

function Slovenia(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124001)">
        <mask
          id="mask0_800_124001"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124001)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#2E42A5"
          />
          <mask
            id="mask1_800_124001"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124001)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V8H36V0H0Z"
              fill="#F7FCFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 16V24H36V16H0Z"
              fill="#C51918"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.4582 5.03626C15.4582 5.03626 13.0904 4.04233 10.1454 4.04233C7.20035 4.04233 4.83252 5.03626 4.83252 5.03626C4.83252 5.03626 5.09602 9.03098 5.5125 11.1472C5.69032 12.0507 6.54502 13.3686 7.3188 13.9923C8.20076 14.7033 10.1454 15.5456 10.1454 15.5456C10.7081 15.2009 11.7603 15.0459 13.1051 13.9923C14.45 12.9388 14.7843 11.1472 14.7843 11.1472L15.4582 5.03626Z"
              fill="#2E42A5"
            />
            <path
              d="M15.145 4.9057L16.1311 5.34342L15.4542 11.366C15.2171 12.6407 14.6238 13.6459 13.6752 14.3891C13.1605 14.7923 12.6582 15.0935 12.1196 15.3438C11.8156 15.4851 10.544 16.0673 10.555 16.0626C10.4276 16.1172 10.331 16.165 10.2525 16.213L10.1295 16.2884L9.99675 16.2309C8.67964 15.6604 7.45079 14.8926 6.84013 14.4004C6.00653 13.7284 5.12758 12.3533 4.9402 11.4012C4.66002 9.97754 4.40876 8.01664 4.23242 5.34342L5.11825 4.93149C5.29325 7.58456 5.50451 9.69948 5.77963 11.0974C5.94241 11.9245 6.75291 13.1925 7.4923 13.7885C8.03875 14.229 8.9191 14.7175 10.1295 15.2487C10.2017 15.2111 10.2818 15.1738 10.3733 15.1346C10.3759 15.1335 11.1993 14.8085 11.4854 14.6755C11.9873 14.4422 12.4539 14.1625 12.9342 13.7862C13.7764 13.1265 14.302 12.238 14.5145 11.1093L15.145 4.9057Z"
              fill="#C51918"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.23535 11.0242C6.23535 11.0242 6.44998 11.6079 6.84677 12.2634C7.42947 12.4 7.78601 12.3928 7.8987 12.2807C8.22471 11.9563 9.38463 11.8177 9.60106 12.0948C9.73458 12.2657 10.2039 12.3839 10.7171 12.2275L10.6599 12.2365C10.749 12.2077 10.9578 12.1342 11.0865 12.0888C11.1403 12.0699 11.1801 12.0559 11.1913 12.0521C11.3845 11.9873 11.5264 11.9533 11.6711 11.9437C11.8523 11.9318 12.0262 11.9618 12.2104 12.0397C12.6153 12.2111 13.1149 12.2909 13.4551 12.239C13.8709 11.5952 14.1675 11.0242 14.1675 11.0242L12.1928 9.33963L11.4079 10.0967L10.1038 8.44412L9.01206 10.0967L8.1749 9.33963L6.23535 11.0242ZM7.37695 13.0145C7.28579 12.9053 7.19964 12.7924 7.11867 12.6785C7.6241 12.7604 7.96729 12.7173 8.15822 12.5274C8.2484 12.4376 8.51597 12.3506 8.8204 12.3143C8.96233 12.2973 9.0985 12.2931 9.2029 12.3019C9.25081 12.306 9.28941 12.3127 9.3154 12.3206C9.32382 12.3232 9.32356 12.3229 9.31482 12.3118L9.31324 12.3098C9.54601 12.6056 10.178 12.7642 10.7743 12.5715L10.7171 12.5805C10.8784 12.5364 11.1689 12.4349 11.2733 12.3984L11.3096 12.3858C11.4752 12.3302 11.5893 12.3029 11.6957 12.2959C11.8184 12.2878 11.9342 12.3077 12.0656 12.3633C12.4241 12.5151 12.8409 12.6054 13.2082 12.6077C13.1299 12.7203 13.0491 12.8323 12.9666 12.941C12.681 13 12.2392 12.9225 11.8828 12.7495C11.7162 12.6687 11.5572 12.6372 11.3913 12.6497C11.2601 12.6597 11.133 12.6946 10.9612 12.7607C10.9511 12.7646 10.9158 12.7788 10.8683 12.798C10.756 12.8434 10.5752 12.9165 10.4982 12.945L10.5628 12.9334C10.1168 13.0863 9.72643 12.9736 9.61497 12.8099C9.41606 12.5179 8.37362 12.6608 8.08033 12.9954C8.00215 13.0846 7.76619 13.1009 7.37695 13.0145ZM7.76507 13.4235C7.78704 13.4435 7.80924 13.4633 7.83164 13.4827C8.84773 14.3634 10.1038 14.795 10.1038 14.795C10.1038 14.795 11.5999 14.3926 12.4491 13.5454C12.5215 13.4731 12.5941 13.3948 12.6663 13.312C12.3567 13.2984 12.0163 13.2087 11.7208 13.0653C11.6122 13.0126 11.5187 12.9941 11.4195 13.0016C11.3317 13.0083 11.2357 13.0347 11.0946 13.0889C11.0908 13.0904 11.0816 13.0941 11.0681 13.0995C10.9817 13.134 10.7194 13.239 10.5628 13.2864L10.6274 13.2748C10.1018 13.4696 9.54376 13.3158 9.3261 13.024C9.30681 13.0173 9.27654 13.0113 9.23818 13.0076C9.15086 12.9991 9.03555 13.0032 8.91499 13.0197C8.6567 13.0551 8.43112 13.1392 8.35652 13.2244C8.23111 13.3675 8.03443 13.4307 7.76507 13.4235Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.04052 5.88619H7.24951L7.86302 5.37531L7.24951 4.83546H8.04052L8.37451 4.31143L8.70985 4.83546H9.49951L8.91668 5.34289L9.4342 5.88619H8.70985L8.37451 6.43919L8.04052 5.88619Z"
              fill="#FECA00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.7686 5.88619H10.9775L11.591 5.37531L10.9775 4.83546H11.7686L12.1025 4.31143L12.4379 4.83546H13.2275L12.6447 5.34289L13.1622 5.88619H12.4379L12.1025 6.43919L11.7686 5.88619Z"
              fill="#FECA00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.67529 7.5675H8.88428L9.49778 7.05662L8.88428 6.51676H9.67529L10.0093 5.99274L10.3446 6.51676H11.1343L10.5514 7.02419L11.069 7.5675H10.3446L10.0093 8.1205L9.67529 7.5675Z"
              fill="#FECA00"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124001">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Slovenia;
